(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ar26-product-landing"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ar26-lander').forEach((root) => {
    if (root.dataset.ar26Bound === 'true') return;
    root.dataset.ar26Bound = 'true';

    const mainImage = root.querySelector('[data-ar26-gallery-main]');
    root.querySelectorAll('[data-ar26-gallery-image]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!mainImage) return;
        mainImage.src = thumb.dataset.ar26GalleryImage;
        mainImage.alt = thumb.dataset.ar26GalleryAlt || mainImage.alt;
        root.querySelectorAll('[data-ar26-gallery-image]').forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });

    const quantity = root.querySelector('input[name="quantity"]');
    root.querySelectorAll('[data-ar26-quantity-change]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!quantity) return;
        const nextValue = Math.max(1, Number(quantity.value || 1) + Number(button.dataset.ar26QuantityChange));
        quantity.value = String(nextValue);
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    const wishlist = root.querySelector('[data-ar26-wishlist]');
    if (wishlist) {
      const storageKey = `ar26-wishlist-${wishlist.dataset.productKey}`;
      try {
        wishlist.setAttribute('aria-pressed', localStorage.getItem(storageKey) === 'true' ? 'true' : 'false');
      } catch (error) {}
      wishlist.addEventListener('click', () => {
        const nextState = wishlist.getAttribute('aria-pressed') !== 'true';
        wishlist.setAttribute('aria-pressed', nextState ? 'true' : 'false');
        try {
          localStorage.setItem(storageKey, String(nextState));
        } catch (error) {}
      });
    }

    const lightbox = document.querySelector('[data-ar26-lightbox]');
    const lightboxImage = lightbox?.querySelector('[data-ar26-lightbox-image]');
    root.querySelector('[data-ar26-expand]')?.addEventListener('click', () => {
      if (!mainImage || !lightbox || !lightboxImage) return;
      lightboxImage.src = mainImage.currentSrc || mainImage.src;
      lightboxImage.alt = mainImage.alt;
      lightbox.showModal();
    });
    lightbox?.querySelector('[data-ar26-lightbox-close]')?.addEventListener('click', () => lightbox.close());
    lightbox?.addEventListener('click', (event) => {
      if (event.target === lightbox) lightbox.close();
    });

    const videoLoader = root.querySelector('[data-ar26-video-load]');
    const videoTemplate = root.querySelector('[data-ar26-video-template]');
    videoLoader?.addEventListener('click', () => {
      if (!(videoTemplate instanceof HTMLTemplateElement)) return;
      const videoFragment = videoTemplate.content.cloneNode(true);
      const video = videoFragment.querySelector('video');
      videoLoader.replaceWith(videoFragment);
      if (!video) return;
      video.load();
      const playback = video.play();
      if (playback && typeof playback.catch === 'function') playback.catch(() => {});
    }, { once: true });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-header"]) return;
  try {
    
  (() => {
    const bindProductMenu = (root = document) => {
      root.querySelectorAll('[data-site-header]').forEach((header) => {
        const trigger = header.querySelector('[data-product-menu-trigger]');
        const item = header.querySelector('[data-product-menu]');
        const panel = header.querySelector('[data-product-menu-panel]');
        if (!trigger || !item || !panel || trigger.dataset.productMenuBound === 'true') return;

        trigger.dataset.productMenuBound = 'true';
        const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
        let closeTimer = 0;

        const setOpen = (open) => {
          window.clearTimeout(closeTimer);
          item.classList.toggle('is-open', open);
          header.classList.toggle('product-menu-open', open);
          trigger.setAttribute('aria-expanded', String(open));
          panel.setAttribute('aria-hidden', String(!open));
        };

        const scheduleClose = () => {
          window.clearTimeout(closeTimer);
          closeTimer = window.setTimeout(() => setOpen(false), 110);
        };

        item.addEventListener('pointerenter', () => {
          if (hoverQuery.matches) setOpen(true);
        });
        item.addEventListener('pointerleave', () => {
          if (hoverQuery.matches) scheduleClose();
        });
        panel.addEventListener('pointerenter', () => {
          if (hoverQuery.matches) setOpen(true);
        });
        panel.addEventListener('pointerleave', () => {
          if (hoverQuery.matches) scheduleClose();
        });

        trigger.addEventListener('click', () => {
          setOpen(trigger.getAttribute('aria-expanded') !== 'true');
        });
        trigger.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowDown') return;
          event.preventDefault();
          setOpen(true);
          panel.querySelector('a[href]')?.focus();
        });

        header.addEventListener('focusout', (event) => {
          if (event.relatedTarget && header.contains(event.relatedTarget)) return;
          scheduleClose();
        });

        document.addEventListener('click', (event) => {
          if (!header.contains(event.target)) setOpen(false);
        });
        document.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape' || trigger.getAttribute('aria-expanded') !== 'true') return;
          setOpen(false);
          trigger.focus();
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => bindProductMenu(), { once: true });
    } else {
      bindProductMenu();
    }

    document.addEventListener('shopify:section:load', (event) => bindProductMenu(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
